import { Platform } from "react-native";
import VersionCheck from "react-native-version-check";

import { APP_ANDROID_STORE_LINK, APP_IOS_STORE_LINK } from "@/config/constants";

import { VersionCheckResult } from "./types";

export const getLastVersion = async (): Promise<VersionCheckResult> => {
  let updateRequired = false;
  let hasNewVersion = false;
  let storeUrl;

  await VersionCheck.getLatestVersion().then((latestVersion) => {
    const currentVersion = VersionCheck.getCurrentVersion();
    hasNewVersion = latestVersion > currentVersion;
  });

  await VersionCheck.needUpdate({ depth: 3 }).then((res) => {
    updateRequired = res?.isNeeded;
    if (res?.isNeeded) storeUrl = res?.storeUrl;
  });

  if (!storeUrl) {
    storeUrl = Platform.OS === "android" ? APP_ANDROID_STORE_LINK : APP_IOS_STORE_LINK;
  }

  return {
    hasNewVersion,
    updateRequired,
    storeUrl,
  };
};
